import React from 'react'
import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import moment from "moment"
import { ITray } from "../interface/interface"
import font from "../../font/Maison Neue Book.ttf";

const FR_rows = ["Numéro de BP", "Numéro de plateau", "OLPN", "statut", "sku", "Nom", "Nombre de bracelets", "Date de création", "Date de modification"]
const rows = ["bpId", "trayNumber", "OLPN", "status", "skuList", "name", "count", "createdOn", "modifiedOn"]
const filename = 'SKUList.csv'

const processRow = (data: ITray, sku: string) => {
  var finalVal = '';
  for (var j = 0; j < rows.length; j++) {
    var innerValue = '', result = ''
    switch (rows[j]) {
      case 'count':
        innerValue = data.skuList.length.toString();
        break;
      case 'OLPN':
        innerValue = data.OLPN ? data.OLPN.OLPN : '';
        break;
      case 'skuList':
        innerValue = data.skuList.length ? data?.skuList[0]?.sku : sku;
        break
      case 'name':
        innerValue = data.skuList ? data?.skuList[0]?.barcode3 : ''
        break
      case 'createdOn':
        innerValue = moment(new Date(data.createdOn)).format("DD/MM/YYYY HH:mm").toString()
        break
      case 'modifiedOn':
        innerValue = moment(new Date(data.modifiedOn)).format("DD/MM/YYYY HH:mm").toString()
        break
      default:
        innerValue = data[rows[j]] ? data[rows[j]]?.toString() : '';
    }
    if (innerValue) {
      result = innerValue?.replace(/"/g, '""');
      if (result.search(/("|,|\n)/g) >= 0)
        result = '"' + result + '"';
    }
    if (j > 0)
      finalVal += ',';
    finalVal += result;
  }
  return finalVal + '\n';
}

export const downloadCSV = (data: ITray[], sku: string | undefined) => {
  if (data.length === 0) return
  if (!sku) sku = ''
  var csvFile = "";
  csvFile = FR_rows.join(",") + '\n'
  for (var i = 0; i < data.length; i++) {
    csvFile += processRow(data[i], sku);
  }

  var link = document.createElement("a");
  if (link.download !== undefined) {
    link.href = "data:application/csv;charset=UTF-8,%EF%BB%BF" + encodeURIComponent(csvFile);
    link.setAttribute("download", filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

Font.register({ family: "Maison Neue", src: font, format: "truetype" })

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
  },
  section: {
    paddingTop: '5%',
    flexGrow: 1,
    fontSize: '16px'
  },
  center: {
    fontFamily: "Maison Neue",
    textAlign: 'center',
    alignItems: "center",
  },
  image: {
    alignSelf: 'center',
    textAlign: 'center',
    alignItems: "center",
    width: "50%",
    paddingTop: '5%',
  },
  legend: {
    textAlign: 'center',
    fontStyle: "italic",
    color: 'grey',
    fontSize: '14px'
  },
  count: {
    paddingLeft: "1%",
    fontFamily: "Maison Neue",
  },
  olpn: {
    paddingLeft: "1%",
    fontFamily: "Maison Neue"
  },
  name: {
    fontFamily: "Maison Neue",
    paddingLeft: "1%",
    paddingTop: '5%'
  }
});

export const downloadPDF = (data, photos) => {
  return (
    <Document>
      {data?.map((elem, index) => (
        <Page size="A4" style={styles.page}>
          <View style={styles.section}>
            <Text style={styles.center}>BP: {elem.bpId}</Text>
            <Text style={styles.center}>OLPN: {elem.OLPN ? elem.OLPN.OLPN.length ? elem.OLPN.OLPN : "Colis en cours" : ""}</Text>
            <Text style={styles.center}>Numero de plateau: {elem.trayNumber}</Text>
            <Image style={styles.image} src={photos[index]} />
            <Text style={styles.legend}>Photo prise le {moment(elem.modifiedOn).format("DD/MM/YYYY HH:mm")}</Text>
            <Text style={styles.name}>{`SKU:`} {elem.skuList ? elem?.skuList[0]?.sku : ""}</Text>
            <Text style={styles.count}>{`Libellé article:`} {elem?.skuList ? elem?.skuList[0]?.barcode3 : ""}</Text>
            <Text style={styles.count}>{`Nombre de bracelets:`} {elem?.skuList ? elem?.skuList.length : 0}</Text>
          </View>
        </Page>
      ))}
    </Document>
  )
}